import React from 'react';
import StateTaxForm from '../components/StateTaxForm';

const DamanDiu = () => {
  return <StateTaxForm stateKey='damanDiu' />;
};

export default DamanDiu;
